export enum EStatusRetornoBancario {
  Pendente = 1,
  Baixado = 2,
  NaoEncontrado = 3,
  Protestado = 4,
  Negativado = 5,
  EntradaEfetivada = 6,
  EntradaRejeitada = 7,
  Descontado = 9,
}
